/**
 * Cambiar como se llama una tarjeta en la tienda (0095).
 *
 * El nombre del sistema no se toca: "IPHONE 17 PRO 256GB" sigue asi en el
 * mostrador, en las listas y en los tickets. Esto es solo lo que lee el
 * cliente, y vacio vuelve al automatico.
 */
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Campo } from "@/components/ui/campo";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export interface Renombrando {
  clave: string;
  automatico: string;
  actual: string | null;
}

export function DialogNombre({
  renombrando,
  guardando,
  onGuardar,
  onCerrar,
}: {
  renombrando: Renombrando | null;
  guardando: boolean;
  onGuardar: (nombre: string) => void;
  onCerrar: () => void;
}): JSX.Element {
  return (
    <Dialog open={renombrando !== null} onOpenChange={(v) => !v && onCerrar()}>
      <DialogContent tamano="sm">
        {renombrando ? (
          <Formulario
            renombrando={renombrando}
            guardando={guardando}
            onGuardar={onGuardar}
            onCerrar={onCerrar}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}

function Formulario({
  renombrando,
  guardando,
  onGuardar,
  onCerrar,
}: {
  renombrando: Renombrando;
  guardando: boolean;
  onGuardar: (nombre: string) => void;
  onCerrar: () => void;
}): JSX.Element {
  const [nombre, setNombre] = useState(renombrando.actual ?? "");

  return (
    <form
      className="contents"
      onSubmit={(e) => {
        e.preventDefault();
        onGuardar(nombre.trim());
      }}
    >
      <DialogHeader>
        <DialogTitle>Nombre en la tienda</DialogTitle>
        <DialogDescription>
          Solo cambia lo que lee el cliente. En el sistema sigue igual.
        </DialogDescription>
      </DialogHeader>

      <Campo label="Cómo se muestra" ayuda={`Vacío, dice «${renombrando.automatico}».`}>
        <Input
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          placeholder={renombrando.automatico}
          maxLength={60}
        />
      </Campo>

      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCerrar}>
          Cancelar
        </Button>
        <Button type="submit" disabled={guardando}>
          {guardando ? "Guardando…" : "Guardar"}
        </Button>
      </DialogFooter>
    </form>
  );
}
